import React from 'react';
import { connect } from 'react-redux';
import { Templates } from 'views/settings/templates/templates';
import { settingEntity } from 'src/enums/settings';
import { withErrorBoundary } from '@oliasoft-open-source/react-ui-library';
import { selectUserTemplates } from 'src/store/entities/templates/selectors';

const UserTemplates = ({ templates }) => {
  return <Templates templates={templates} entity={settingEntity.USER} />;
};

const mapStateToProps = (state) => {
  const templates = selectUserTemplates(state);
  return {
    templates,
  };
};

const Container = withErrorBoundary(connect(mapStateToProps)(UserTemplates));

export { Container as UserTemplates };
